module.exports = __webpack_public_path__ + "static/media/dashboard-active.43d42950.svg";